<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { entry } from "../stores.js";

  onMount(async () => {
    window.scroll(0, 0);
    if (!$entry || !$entry.complete) {
      push("/");
    }
  });
</script>

<style>
  h6, ul {
    margin-block-start: 0.25rem;
    font-weight: 400;
  }
</style>

<h2>メールアドレスのご登録</h2>
<p>ご登録されたメールアドレスに、申込みURLを送信しました。</p>
<p>現時点では申込みは完了しておりません。</p>
<p class="ws-pl">ご案内メールの申込みURLより申込み手続きを行ってください。
※お申込みは先着順となります。予定数に達し次第、締め切りとさせていただきます。</p>
<p class="ws-pl">いかなる場合でも、メールの再送はできません。
※メールを削除または紛失した場合は、再度受付サイトにてメールアドレスの登録手続きを行ってください。</p>
<h6>メールが届かない場合は以下をご確認ください。</h6>
<ul>
  <li>迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。</li>
  <li>上記をご確認いただき、ご案内メールが届いていない場合は、「funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録手続きを行ってください。</li>
</ul>
